var cov_dguqpp2om = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Slider/Indicator.tsx",
      hash = "b7b84752e1a95cc95747b043cc7c91deb4f16ced",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Slider/Indicator.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 18
        },
        end: {
          line: 8,
          column: 74
        }
      },
      "1": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 75
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 18
          },
          end: {
            line: 8,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 8,
            column: 40
          },
          end: {
            line: 8,
            column: 49
          }
        }, {
          start: {
            line: 8,
            column: 52
          },
          end: {
            line: 8,
            column: 74
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Slider/Indicator.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import draggable from '../hoc/draggable';
import { sliderClass } from './styles';

var Indicator =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Indicator, _PureComponent);

  var _super = _createSuper2(Indicator);

  function Indicator() {
    _classCallCheck(this, Indicator);

    return _super.apply(this, arguments);
  }

  _createClass(Indicator, [{
    key: "render",
    value: function render() {
      cov_dguqpp2om.f[0]++;
      var event = (cov_dguqpp2om.s[0]++, this.props.disabled ? (cov_dguqpp2om.b[0][0]++, undefined) : (cov_dguqpp2om.b[0][1]++, this.props.onDragStart));
      cov_dguqpp2om.s[1]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onMouseDown: event,
          className: sliderClass('indicator'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 9,
            columnNumber: 12
          }
        })
      );
    }
  }]);

  return Indicator;
}(PureComponent);

export default draggable(Indicator);